
const state = {
  id: null,
  node_name: '',
  node_properties: [],
  portal_option_id: undefined,
  subtitle: '',
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'node_name' },
  { key: 'portal_option_id' },
  { key: 'subtitle' },
  { key: 'title' },
  { key: 'value' },
]

export default state
